module.exports = __webpack_public_path__ + "static/media/xt-square.e0aad2ee.mp4";